import { useTranslation } from 'react-i18next';
import Accordion from 'react-bootstrap/Accordion';

import styles from "./styles.module.css";

const LANGUAGES: { [key: string]: string } = {
    en: "English",
    ar: "Arabic"
};

interface LangMenuProp {
    extraStyles?: { [key: string]: string };
    className?: string;
    menuClassName?: string;
    setShowMenu?: React.Dispatch<React.SetStateAction<boolean>>;
}

const SmLangMenu = ({ extraStyles, className, menuClassName, setShowMenu }: LangMenuProp) => {
    const { i18n } = useTranslation(['common']);

    const changeLanguageHandle = (lang: string) => {
        setShowMenu && setShowMenu(false);
        return i18n.changeLanguage(lang);
    };

    return (
        <Accordion className={` ${styles.accordion} ${className}`} style={extraStyles}>
            <Accordion.Item eventKey="0" className={styles.lang__item}>
                <Accordion.Header className={styles.lang__header}>
                    {LANGUAGES[i18n.language]}
                </Accordion.Header>
                <Accordion.Body className={`${styles.lang__body} ${menuClassName}`}>
                    <div
                        className={styles.lang__item}
                        onClick={() => changeLanguageHandle('ar')}
                    >
                        Arabic
                    </div>
                    <div
                        className={styles.lang__item}
                        onClick={() => changeLanguageHandle('en')}
                    >
                        English
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default SmLangMenu;
